export const ProtectedViewState = 'ProtectedViewState';
export const VerifySignature = 'verifySignature';
export const FormFieldsFound = 'formFieldsFound';
export const NoCountry = 'noCountry';
export const PdfADocument = 'PdfADocument';
export const hasUsData = 'hasUsData';
